import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import './UserEdit.css';
import Tabbar from '../../../Components/Tabbar/Tabbar';
import { getOne, edit, getRoles, getUserGroups } from '../../../Store/Actions/RestActions';
import UsersEditAddComponent from '../../../Components/Pages/UsersEditAddComponent';

class UserEditPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accountId: localStorage.getItem("accountId"),
			userName: '',
			firstName: '',
			middleName: '',
			lastName: '',
			notes: '',
			email: '',
			phone: '',
			isAdmin: false,
			isSuperman: false,
			isActive: false,
			isJunior: false,
			isSenior: false,
			roles: [],
			userGroupId: '',
			formErrors: { email: '', password: '' },
			emailValid: false,
			passwordValid: false,
			formValid: false,
			showPassword: false,
		};
		this.form = true;
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateForm = this.validateForm.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}
	componentDidMount() {
		this.props.rolesFetch();
		this.props.userGroupFetch();
		let locationSteal = window.location.pathname.match(/\/users\/(.*)/);
		if (locationSteal.length > 1) {

			this.setState({ id: locationSteal[1] });
			this.props.userFetch(locationSteal[1]);
		}
	}
	componentWillReceiveProps(newProps) {
		if (!newProps.users.length){ // stops propogating users from main page
			this.setState(newProps.users, () => { this.validateField("email", newProps.users.email); });
		}

	}
	handleSelectChange(event) {
		const target = event.target;
		const value = target.value;

		this.setState({ userGroupId: value, userGroup: value });
	}
	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		this.setState({ [name]: value },
			() => { this.validateField(name, value); });
	}

	handleCheckboxChange(roles) {
		this.setState({ roles: roles });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.editUser(this.state, this.state.id);
		// setTimeout(() => this.setState({ fireRedirect: true }), 200);
	}

	validateField(fieldName, value) {

		var passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
		var emailRegex = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
		let fieldValidationErrors = this.state.formErrors;
		let emailValid = this.state.emailValid;
		let passwordValid = this.state.passwordValid;

		switch (fieldName) {
			case 'email':
				emailValid = emailRegex.test(value);
				fieldValidationErrors.email = emailValid ? '' : ' is invalid';
				break;
			case 'password':
				passwordValid = passwordRegex.test(value);
				fieldValidationErrors.password = passwordValid ? '' : ' is too short';
				break;
			default:
				break;
		}
		this.setState({
			formErrors: fieldValidationErrors,
			emailValid: emailValid,
			passwordValid: passwordValid
		}, this.validateForm);
	}

	validateForm() {
		this.setState({ formValid: this.state.emailValid }); //&& this.state.passwordValid});
	}

	render() {
		if (this.props.fireRedirect) {
			return (
				<Redirect to="/users" />
			);
		}
		return (
			<div className="container">
				<Tabbar setActiveTab="users" />
				<div className="contentBox tabbed-content-box editUser">
					<h3>Edit User</h3>
					<UsersEditAddComponent
						{...this.props}
						state={this.state}
						handleInputChange={this.handleInputChange}
						handleCheckboxChange={this.handleCheckboxChange}
						handleSubmit={this.handleSubmit}
						addLabel={false}
						userGroup={
							{ label: "User Group", items: this.props.userGroups, onChange: this.handleSelectChange, userGroupId: this.state.userGroupId }
						}
					/>
				</div>
			</div>
		);
	}
}
const mapStateToProps = state => ({
	users: state.users.data,
	roles: state.roles.data,
	userGroups: state.userGroups.data,
	fireRedirect: state.users.redirect
});
const mapDispatchtoProps = dispatch => ({
	rolesFetch: () => dispatch(getRoles('roles', {})),
	userGroupFetch: () => dispatch(getUserGroups('userGroups', {})),
	userFetch: (id) => dispatch(getOne('users', {}, id)),
	editUser: (data, id) => dispatch(edit('users', data, id)),

});
export default connect(mapStateToProps, mapDispatchtoProps)(UserEditPage);



// WEBPACK FOOTER //
// ./src/Pages/Users/UserEdit/UserEdit.js